import React,{useState} from 'react';
import { Grid, Card, CardContent, Typography, Chip, TextField,Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    card: {
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: theme.spacing(1),
      margin: theme.spacing(2, 0),
      boxShadow: theme.shadows[2],
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.primary.main}`,
      padding: theme.spacing(1, 2),
    },
    name: {
      fontSize: '20px',
    },
    status: {
      fontSize: theme.typography.body1.fontSize,
      fontWeight: 'bold',
    },
    details: {
      padding: theme.spacing(2),
    },
    label: {
      fontWeight: 'bold',
    },
    chipGreen: {
      backgroundColor: theme.palette.success.main,
      color: '#fff',
    },
    chipRed: {
      backgroundColor: theme.palette.error.main,
      color: '#fff',
    },
  }));

  const RegistrationDetailsCard = ({ formInfo,inquiries }) => {
    const classes = useStyles();
    console.log(formInfo,inquiries)
    const [filterValue, setFilterValue] = useState('');

  const filteredInquiries = formInfo?.filteredInqueries?.filter((inquery) => {
    const searchValue = filterValue.toLowerCase();
    return (
      inquery?.country?.toLowerCase().includes(searchValue) ||
      inquery?.nic?.toLowerCase().includes(searchValue) ||
      inquery?.name?.toLowerCase().includes(searchValue) ||
      inquery?.appliedPosition1?.toLowerCase().includes(searchValue)
    );
  });


    return (
      <>
        
      
          <TextField
            label="Filter by Name, Country, NIC, or Applied Position"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            fullWidth
          />

        {filteredInquiries?.map((inquery, index) => (
          <Card className={classes.card} key={index}>
            <div className={classes.header}>
              <Typography className={classes.name}>{inquery?.name}</Typography>
            
              <Chip
                label={inquery?.paymentStatus}
                className={
                  inquery?.paymentStatus === 'paid'
                    ? classes.chipGreen
                    : classes.chipRed
                }
              />
            </div>
            <CardContent className={classes.details}>
  <Grid container spacing={2}>
    <Grid item xs={4} sm={4} style={{
        textAlign: "left",
        fontSize: "10px",
    }}>
      <Typography>
        <strong>NIC:</strong> {inquery?.nic}
      </Typography>
      <Typography>
        <strong>regNumber:</strong> {inquery?.regNumber}
      </Typography>

      <Typography>
        <strong>Passport No:</strong> {inquery?.passportNo}
      </Typography>
      <Typography>
        <strong>Reg No:</strong> {inquery?.regNumber}
      </Typography>

      <Typography>
        <strong>Address</strong> {inquery?.address}
      </Typography>

      <Typography>
        <strong>Phone 1:</strong> {inquery?.phone1}
      </Typography>

      <Typography ><strong>Phone 2:</strong>{inquery?.phone2}</Typography>
    </Grid>

    <Grid item xs={4} sm={4}
    style={{
        textAlign: "left",
        fontSize: "12px",   
    }}
    >      <Typography className={classes.label}>Applied Positions:</Typography>
      <div>
        <Typography>{inquery?.appliedPosition1}</Typography>
        <Typography>{inquery?.appliedPosition2}</Typography>
        <Typography>{inquery?.appliedPosition3}</Typography>
      </div>
      <Typography ><strong>Interview Date:</strong>{inquery?.interviewDate}</Typography>
      <Typography ><strong>Interview Venue:</strong>{inquery?.interviewVenue}</Typography>

    </Grid>

    <Grid item xs={4} sm={4}
    style={{
        textAlign: "left",
        fontSize: "12px",
    }}
    >
      <Typography > <strong>Country: </strong>{inquery?.country}</Typography>

      <Typography ><strong>Payment Method:</strong>{inquery?.paymentMethod}</Typography>

      <Typography ><strong>Payment Date:</strong>{inquery?.paymentDate}</Typography>

      <Typography ><strong>Foreign Client:</strong>{inquery?.foreignClient}</Typography>

      <Typography ><strong>Remarks:</strong>{inquery?.remarks}</Typography>
    

    </Grid>
  </Grid>
</CardContent>

          </Card>
        ))}
      </>
    );
  };
  
  export default RegistrationDetailsCard;
  